/**
 * Normalize CMS string values that were double-JSON-encoded or saved with stray quotes.
 */
export function sanitizeCmsText(value, fallback = '') {
  if (value == null || value === '') return fallback;
  if (typeof value !== 'string') return String(value);

  let text = value.trim();

  for (let i = 0; i < 4; i++) {
    const before = text;

    if ((text.startsWith('"') && text.endsWith('"')) || (text.startsWith("'") && text.endsWith("'"))) {
      try {
        const parsed = JSON.parse(text);
        if (typeof parsed === 'string') {
          text = parsed.trim();
          continue;
        }
      } catch {
        text = text.slice(1, -1).trim();
      }
    }

    text = text.replace(/^\\+"|\\+"$/g, '').trim();
    text = text.replace(/^"+|"+$/g, '').trim();

    if (text === before) break;
  }

  return text || fallback;
}

/** Allow only safe inline HTML from CMS (br, span.highlight). */
export function sanitizeCmsHtml(html, fallback = '') {
  const raw = sanitizeCmsText(html, fallback);
  if (!raw) return fallback;

  return raw
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<iframe[\s\S]*?<\/iframe>/gi, '')
    .replace(/\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/<(\/?)(?!br\b|span\b|\/span\b)[^>]+>/gi, '')
    .replace(/<span(?![^>]*class\s*=\s*["']highlight["'])[^>]*>/gi, '');
}
